import { type ApiResponse } from '@webapp/core/interfaces/api/ApiResponse'
import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type TravelTicketOptionConstructor } from '@webapp/modules/expense/entities/TravelTicketOption'
import { type ITravelTicketRepository } from '../../../business-logic/interfaces/ITravelTicketRepository'
import { type TravelTicketOptionApiModel } from '../../api-models/TravelTicketOptionApiModel'
import { mapTravelTicketOptionApiModel } from '../../mappers/mapTravelTicketOptionApiModel'

interface Dependency {
  httpClient: IHttpClient
}

export class TravelTicketRepository implements ITravelTicketRepository {
  constructor(private readonly deps: Dependency) {}

  async listAttachable(
    userId: number
  ): Promise<TravelTicketOptionConstructor[]> {
    try {
      const res = await this.deps.httpClient.get<
        ApiResponse<TravelTicketOptionApiModel[]>
      >(`/api/v3/travels/`, {
        params: {
          attachable: userId,
          page_size: 9999,
        },
      })

      return res.data.data.map((apiModel) =>
        mapTravelTicketOptionApiModel(apiModel)
      )
    } catch (err) {
      throwRepoErrorFromApiV3Error(err)
    }
  }
}
